import React, { useState, useEffect, useContext } from "react";
import "./header.css";
import { DarkLightModeContext } from "react-light-dark-mode";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Toast from "react-bootstrap/Toast";
import Black_Logo from "../../img/logo/black-logo.png";
import Whote_Logo from "../../img/logo/white-logo.png";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { useGetAllcurriculumQuery } from "../../services/aplms";
import Sideheader from "./Sideheader";
import Loader from "../../loader/Loader";
import Error from "../../errordata/Error";
import mobilebutton from "../../img/icon/navbar.png";
import Accordion from "react-bootstrap/Accordion";
import Mobileleft from "./Mobileleft";
import Dropdown from "react-bootstrap/Dropdown";
import { getToken } from "../../services/LocalStorageService";
import Logout from "./Logout";
import Search from "../../search/Search";

/**
 * Header component that renders the navigation bar with curriculum dropdown and user profile options.
 *
 * @component
 *
 * @example
 * return (
 *   <Header />
 * )
 *
 * @returns {JSX.Element} The rendered Header component.
 *
 * @description
 * This component handles the rendering of the header section of the application. It includes:
 * - A navigation bar with curriculum dropdown.
 * - User profile options.
 * - A responsive design for both desktop and mobile views.
 * - Scroll event handling to add or remove a CSS class based on the scroll position.
 *
 * @function
 * @name Header
 *
 * @hook
 * @name useState
 * @description Manages the state for scroll position and visibility of the mobile menu.
 *
 * @hook
 * @name useEffect
 * @description Adds and removes the scroll event listener and updates the header class based on scroll position.
 *
 * @hook
 * @name useContext
 * @description Retrieves the current theme mode from the DarkLightModeContext.
 *
 * @hook
 * @name useGetAllcurriculumQuery
 * @description Fetches the curriculum data from the API.
 *
 * @returns {JSX.Element} The rendered Header component.
 */
const Header = () => {
  // header new code start

  const [scrolled, setScrolled] = useState(false);

  const handleScroll = () => {
    const offset = window.scrollY;
    if (offset > 0) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const header = document.getElementById("header-number-project");
    if (header) {
      if (scrolled) {
        header.classList.add("scrolled-navbar");
      } else {
        header.classList.remove("scrolled-navbar");
      }
    }
  }, [scrolled]);

  // end header new code

  const toggleShowA = () => setShowA(!showA);
  const [showA, setShowA] = useState(false);

  const token = getToken();

  useContext(DarkLightModeContext);

  const curriculum = useGetAllcurriculumQuery();

  if (curriculum.isLoading)
    return (
      <div>
        <Loader />
      </div>
    );
  if (curriculum.data[0] == null)
    return (
      <div>
        <Error />
      </div>
    );
  if (curriculum.isError) return <h1>data not found </h1>;

  return (
    <>
      <Navbar
        expand="lg"
        className="desktop-view"
        id="header-number-project"
        style={{
          background:
            "linear-gradient(145deg, rgba(255, 255, 255, 0.25), rgba(255, 255, 255, 0.05))",
          backdropFilter: "blur(35px)",
          zIndex: "100",
          margin: "0px 0px 0px 0px",
        }}
      >
        <Container fluid>
          <Navbar.Brand href="/">
            <img className="light" src={Black_Logo} />
            <img className="drack" src={Whote_Logo} />
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls="navbarScroll"
            className="mobile-button"
          />
          <Navbar.Collapse id="navbarScroll">
            <Nav
              className="mx-auto my-2 my-lg-0 header-center-content"
              style={{ maxHeight: "100px" }}
              navbarScroll
            >
              <Dropdown
                className="nav-item dropdown megamenu"
                autoClose={false}
              >
                <Dropdown.Toggle id="dropdown-autoclose-false">
                  <Nav.Link
                    id="megamneu"
                    href="#"
                    aria-expanded="false"
                    className="nav-link dropdown-toggle"
                  >
                    Curriculum
                  </Nav.Link>
                </Dropdown.Toggle>

                <Dropdown.Menu className="border-0 p-0 m-0">
                  <div className="container">
                    <div className="row bg-trans rounded-10 m-0 shadow-sm">
                      <div className="col-lg-12 col-xl-12 pl-0 pr-0 drack-mode-header-drop-down">
                        <div className="row">
                          <Tabs
                            defaultActiveKey="ap"
                            id="uncontrolled-tab-example"
                            className="mb-4 megamenu-top-tabs"
                          >
                            {curriculum.data.map((curriculumdata) => {
                              return (
                                <Tab
                                  eventKey={curriculumdata.slug}
                                  title={curriculumdata.name}
                                >
                                  <Tab.Container
                                    id="left-tabs-example"
                                    defaultActiveKey={curriculumdata.slug}
                                  >
                                    <Sideheader
                                      propsintroData={curriculumdata.slug}
                                    />
                                  </Tab.Container>
                                </Tab>
                              );
                            })}
                          </Tabs>
                        </div>
                      </div>
                      <div className="col-lg-5 col-xl-4 px-0 d-none d-lg-block megaimaga"></div>
                    </div>
                  </div>
                </Dropdown.Menu>
              </Dropdown>
              <Search />
            </Nav>

            {token ? (
              <>
                <Nav
                  className="ms-auto my-2 my-lg-0 header-right"
                  style={{ maxHeight: "100px" }}
                  navbarScroll
                >
                  <Logout />
                  <Nav.Link href="/My-Profile" className="Profile-dropdown">
                    Profile
                  </Nav.Link>
                </Nav>
              </>
            ) : (
              <>
                <Nav
                  className="ms-auto my-2 my-lg-0 header-right"
                  style={{ maxHeight: "100px" }}
                  navbarScroll
                >
                  <Nav.Link href="/login">Login</Nav.Link>
                  <Nav.Link href="/Sign-Up" className="Profile-dropdown join-now">
                    Join Now
                  </Nav.Link>
                </Nav>
              </>
            )}
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <Navbar expand="lg" className="mobile-view">
        <Container fluid>
          <div className="navbar-left">
            <Button variant="navbar" onClick={toggleShowA}>
              <img src={mobilebutton} alt="Mobile menu" />
            </Button>
            <Navbar.Brand href="/">
              <img className="light" src={Black_Logo} alt="Logo Light" />
              <img className="drack" src={Whote_Logo} alt="Logo Dark" />
            </Navbar.Brand>
          </div>
          <div className="navbar-right">
            {token ? (
              <>
                <Logout />
                <Nav.Link href="/My-Profile" className="Profile-dropdown">
                  Profile
                </Nav.Link>
              </>
            ) : (
              <Nav.Link href="/login" className="Profile-dropdown join-now">
                Login
              </Nav.Link>
            )}
          </div>
        </Container>
      </Navbar>

      <Toast
        show={showA}
        onClose={toggleShowA}
        className="menu-drop-down-popup"
      >
        <Toast.Body>
          {curriculum.data.map((curriculumdata) => {
            return (
              <Accordion>
                <Accordion.Item eventKey="0">
                  <Accordion.Header>{curriculumdata.name}</Accordion.Header>
                  <Accordion.Body className="Accordion-Accordion_style">
                    <Mobileleft propsintroData={curriculumdata.slug} />
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            );
          })}
        </Toast.Body>
      </Toast>
    </>
  );
};

export default Header;
